import { ReactNode } from "react";
import { CheckCircle2 } from "lucide-react";

interface ModuleStepCardProps {
  icon: ReactNode;
  title: string;
  body: string;
  subtext?: string;
  highlights?: string[];
  action: ReactNode;
}

const ModuleStepCard = ({ icon, title, body, subtext, highlights, action }: ModuleStepCardProps) => (
  <div className="space-y-6">
    <div className="flex flex-col items-center text-center space-y-4">
      <div className="w-16 h-16 rounded-2xl bg-muted/60 flex items-center justify-center border border-border/50">
        {icon}
      </div>
      <h2 className="font-heading text-xl font-bold text-foreground">{title}</h2>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">{body}</p>
      {subtext && <p className="text-xs text-muted-foreground/70 font-mono">{subtext}</p>}
    </div>
    {highlights && (
      <div className="space-y-2">
        {highlights.map((h, i) => (
          <div key={i} className="flex items-center gap-2 text-sm text-foreground/80">
            <CheckCircle2 className="w-3.5 h-3.5 text-primary shrink-0" />
            {h}
          </div>
        ))}
      </div>
    )}
    <div>{action}</div>
  </div>
);

export default ModuleStepCard;
